var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 64.9199C50.1731 64.9199 64.5 50.593 64.5 32.9199C64.5 15.2468 50.1731 0.919922 32.5 0.919922C14.8269 0.919922 0.5 15.2468 0.5 32.9199C0.5 50.593 14.8269 64.9199 32.5 64.9199Z",
    fill: "#F45D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.82 23.0026L31.3886 30.5712L28.2018 33.7579L23.82 29.3762C22.06 27.6161 22.06 24.7626 23.82 23.0026ZM35.1387 32.3979L34.177 33.3597L42.144 41.3265L40.5506 42.9199L32.5836 34.953L24.6167 42.9199L23.0233 41.3265L33.5452 30.8045C32.8832 29.163 33.5676 26.7989 35.3721 24.9943C37.5721 22.7943 40.604 22.2593 42.144 23.7993C43.6839 25.3393 43.149 28.3712 40.9489 30.5712C39.1444 32.3757 36.7802 33.0601 35.1387 32.3979Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5 0.919922)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.e90819e7e357f5813e489a9a5f862873.svg";
export { ForwardRef as ReactComponent };